import { EntityDefinition } from '../../../../../types/entity-definition.interface';
import { AutomaticMeasureFollow } from '../../../../../types/measure.interface';

export const automaticMeasureFollowUpDefinition: EntityDefinition<AutomaticMeasureFollow> = {
  entityType: 'AutomaticMeasureFollow',
  i18nBase: 'entities.automaticMeasure',
  enableFiltering: true,
  // No client-side default: the API serves the configured measure order
  // (measure-type sort order, then measure sort order).
  defaultSortField: null,
  list: {
    columns: [
      {
        field: 'name',
        headerKey: 'entities.measure.singular',
        sortable: true,
        filterable: true,
        template: 'measureName',
        class: 'min-w-[200px]',
        contentClass: 'line-clamp-1',
        showTooltip: true,
      },
      {
        field: 'measureTypeName',
        filterField: 'measureTypeId',
        headerKey: 'common.labels.measureType',
        sortable: true,
        filterable: 'multiselect',
      },
      {
        field: 'localisationName',
        filterField: 'localisationId',
        headerKey: 'entities.location.singular',
        sortable: true,
        filterable: 'multiselect',
      },
      {
        field: 'lastValueDate',
        headerKey: 'common.labels.lastValueDate',
        sortable: true,
        template: 'datetime',
        filterable: true,
        filterType: 'datetime',
      },
    ],
  },
  fields: [],
  messages: {
    dialogTitles: { create: () => '', edit: () => '', delete: () => '' },
    buttons: { add: () => '', create: () => '', edit: () => '', delete: () => '' },
  },
};
